import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import getInitialState from './state';

export default {
  namespaced: true,
  state: getInitialState(),
  getters,
  mutations,
  actions
};
